import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import AddressSearchParams from './AddressSearchParams';
import ButtonRow from '../../../Elements/ButtonRow';
import AddressService from '../../../Services/AddressService';
import AddressItem from '../../../Domain/AddressItem';
import SearchAddressPanel from './SearchAddressPanel';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditAddressWindowDescription from './EditAddressWindowDescription';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import UserGuideTitle from '../../../Elements/UserGuideTitle';

class AddressAdmin extends React.Component {
  static defaultProps = {
    EntityId: '',
    EntityTypeId: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      addressList: [],
      selected: -1,
      pageNumber: 1,
      shownPanel: AddressSearchParams.isThereAnySearchParameter() ? ShownPanelsEnum.Search : ShownPanelsEnum.None,
      searchItem: new AddressSearchParams(),
    };
    if (this.props.EntityId !== '' && this.props.EntityTypeId !== '') {
      this.state.searchItem.EntityId = this.props.EntityId;
      this.state.searchItem.EntityTypeId = this.props.EntityTypeId;
    }

    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    AddressItem.editFunction = this.editAddress.bind(this);
  }

  buildNewAddress() {
    const newAddress = new AddressItem();
    newAddress.EntityId = this.props.EntityId;
    newAddress.EntityTypeId = this.props.EntityTypeId;
    return newAddress;
  }

  editAddress(addressId, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selected: addressId,
      selectedItem: item,
    });
  }

  startSearch(searchItem) {
    this.setState({
      searchItem: searchItem,
    });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.Search,
          <SearchAddressPanel
            searchItem={this.state.searchItem}
            clickOnCancel={() =>
              this.setState({
                shownPanel: ShownPanelsEnum.None,
                selected: -1,
              })
            }
            startSearch={this.startSearch}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.buildNewAddress()}
            windowDescription={EditAddressWindowDescription}
            errorCode='AA86'
            clickOnSave={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
              this.refresh();
            }}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            windowDescription={EditAddressWindowDescription}
            errorCode='AA99'
            clickOnSave={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
              this.refresh();
            }}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
          />
        )}
      </div>
    );
  }

  renderButtonsAndPanels() {
    if (this.props.EntityId !== '') {
      return (
        <FigmaButtonRow
          className={'InnerMenuButtonFigmaList'}
          buttons={[
            {
              iconName: 'fa-solid fa-plus-circle',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.showPanel(ShownPanelsEnum.AddNewItem),
              tooltip: 'Create Address',
              roleKey: 'AddressAdmin_CreateAddress',
            },
          ]}
        />
      );
    }
    return (
      <ButtonRow
        labels={['Search']}
        keys={[ShownPanelsEnum.Search]}
        icons={['fa-solid fa-search']}
        roleKeys={['User']}
        value={this.state.shownPanel}
        onClick={this.showPanel}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderPanels()}
        <div className='text-end small'>
          <UserGuideTitle title='Contacts'>User guide</UserGuideTitle>
        </div>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={AddressItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={AddressService.GetAddressListBySearching}
          convertDBItemsFunction={AddressService.ConvertDBItems}
          showSearchStrip={false}
          searchParamsType={{}}
          searchItem={this.state.searchItem}
          errorCode='AA156'
        />
      </div>
    );
  }
}

export default AddressAdmin;
